// import axios from "axios"
import { api } from "../util/APIConfig"

export const login = async values =>
  await api.post("/authentication/authenticate/", values)

export const forgotPassword = async email =>
  await api(`/user/ForgotPassword/ForgotPassword?email=${email}`)
export const resetPassword = async body =>
  await api.post("/User/ForgotPassword/SetPassword", body)

export const getProfileImage = async () =>
  await api("/user/Student/view-profile", {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })

/**
 * Object representing academy data.
 * @typedef {Object} AcademyData
 * @property {Array} academies - Array of academy objects.
 * @property {number} count - Total count of academies.
 * @property {number} progress - Completion percentage of all academies.
 * @property {number} left - Total number of videos left to watch.
 * @property {number} completed - Total number of videos completed.
 */

/**
 * Get academy data.
 * @function
 * @async
 * @param {number} page - Page number.
 * @returns {Promise<AcademyData>} Academy data.
 */
export const getAcademy = async page => {
  const {
    data: { data }
  } = await api(`academy/Academy/GetAllAcademy?pageNo=${page}&pageSize=4`)

  return {
    academies: data.academies,
    count: data.totalCount,
    progress: data.totalProgress.completionPercent,
    left: data.totalProgress.videosLeft,
    completed: data.totalProgress.videsoCompleted
  }
}

export const getTutorAcademy = async page => {
  const {
    data: { data }
  } = await api(`academy/api/Tutor/Academy/GetAllAcademy?pageNo=${page}&pageSize=16`)

  return {
    academies: data.academies,
    count: data.totalCount
  }
}

export const getBlogs = async ({
  pageParam = 1,
  pageSize,
  startDate,
  endDate
}) => {
  let url = `/blog/blog?pageNo=${pageParam}&pageSize=${pageSize}`
  if (startDate && endDate) {
    url = url + `&startDate=${startDate}&EndDate=${endDate}`
  }
  return await api(url)
}

export const getReadingList = async () => await api("/readinglist/reading-list")

export const updateBlogStatus = async id =>
  await api.post("/blog/blog/MarkRead", {
    blogId: id
  })

export const getBlogDetail = async id => await api(`/blog/blog/${id}`)

export const getTutorAcademyDetail = async id =>
  await api(`/academy/api/tutor/academy/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })
export const getAcademyDetail = async id => await api(`/academy/academy/${id}`)

export const getTutorAcademyProgressSummary = async academyId =>
  await api(`/academy/api/tutor/UserVideoProgress/Academy/${academyId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })

export const upsertTutorVideoProgress = async ({ videoId, academyId, positionSeconds, percent }) =>
  await api.put(
    `/academy/api/tutor/UserVideoProgress`,
    { videoId, academyId, positionSeconds, percent },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }
  )

export const downloadTutorCertificate = async academyId =>
  await api(`/academy/api/tutor/Certificate/${academyId}`, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })

export const getBooks = async () => await api("/library/book")

export const getNews = async () => await api(`/news/news`)

export const getNewsAdmin = async (pageNo, pageSize) =>
  await api(`/news/admin/News?pageNo=${pageNo}&pageSize=${pageSize}`)

export const getCourses = async (pageNo, pageSize, isUpcoming, date, title) =>
  await api(
    `/course/course?pageNo=${pageNo}&pageSize=${pageSize}&upcoming=${isUpcoming}&date=${date}&title=${title}`
  )

export const getEssays = async () => await api(`/essay/essay`)

export const uploadEssay = async body => await api.post("/essay/essay", body)

export const getPersonalStatement = async () =>
  await api("/personal-statement/personal-statement")

export const uploadPersonalStatement = async body =>
  await api.post("/personal-statement/personal-statement", body)

export const updateProfile = async body =>
  await api.post("/user/student/update-pofile", body)

export const createBooking = async body =>
  await api.post("/user/admin/booking/create", body)

export const createUpsell = async body =>
  await api.post("/user/admin/upsell/create", body)

export const updateVideoWatchStatus = async id =>
  await api.post("/academy/UserVideo", {
    videoId: id
  })

export const deleteVideoWatchStatus = async id =>
  await api.delete(`/academy/UserVideo/${id}`)

export const getLearnSubjects = async (pageNo, pageSize) =>
  await api(`/training/Subject/?PageNo=${pageNo}&PageSize=${pageSize}`)

export const getLearning = async () => await api("/training/api/Learning")

export const getLearnLastSessions = async () =>
  await api("/training/api/Learning/ContinueSession")

export const getUpgrades = async () =>
  await api("/upgrade/userUpgrade/GetAllUpgrades")

export const upgrade = async id =>
  await api.post("/upgrade/UserUpgrade/Add-To-Cart?upgradeId=" + id)

export const getTopics = async learningId =>
  await api(`/training/api/LearnTopic/GetAllTopic/?learningId=${learningId}`)

export const getSubTopics = async TopicId =>
  await api(`/training/Lesson/?TopicId=${TopicId}`)

export const getSubTopicDetail = async subTopicId =>
  await api(`/training/api/LearnTopic/GetContent/?subTopicId=${subTopicId}`)

export const getSubTopicDetailCount = async learningId =>
  await api(
    `/training/api/LearnTopic/GetAllTopicCount/?learningId=${learningId}`
  )

export const createCompleteSession = async body =>
  await api.post("/training/api/Learning/CreateCompletion", body)

export const getReviseSections = async id =>
  await api(`/Subject/SectionNumber/${id}`)

export const getReviseSectionsData = async (admisionId, sectionid) =>
  await api(
    `/Revise/api/Revise/GetReviseDashBoardDataAsync?admissionTestId=${admisionId}&sectionId=${sectionid}`
  )

export const getAdmissionTests = async () => await api("/Subject/AdmissionTest")

export const getSubjectsForRevise = async (admisionId, sectionid) =>
  await api(
    `/Question/Question/GetSectionSubjectsForRevise?admissionTestId=${admisionId}&sectionId=${sectionid}`
  )
export const getTutorSubjectsForRevise = async (admisionId, sectionid) =>
  await api(
    `/Question/Tutor/Question/GetSectionSubjectsForRevise?admissionTestId=${admisionId}&sectionId=${sectionid}`
  )

export const getTopicsForSubject = async subjectId =>
  await api(`/Subject/Topic/?subjectId=${subjectId}`)
export const getQuestionCount = async (
  admisionId,
  sectionid,
  subjectId,
  topicIds
) =>
  await api(
    `/Question/Question/GetQuestionCount?${topicIds}&AdmissionTestId=${admisionId}&sectionId=${sectionid}&SubjectId=${subjectId}`
  )

export const getSessionsForRevise = async (admisionId, sectionid) =>
  await api(
    `/Revise/api/Revise/GetReviseDashBoardData?admissionTestId=${admisionId}&sectionId=${sectionid}`
  )

export const getDegrees = async () => await api(`/Subject/Degree`)

export const getSeminarsUpcoming = async (
  pageNo,
  pageSize,
  monthNumber,
  startDate,
  endDate,
  subjectIds
) => {
  function getURLBasedOnInputs(monthNumber, startDate, endDate, subjectIds) {
    let requestUrl = `/Seminar/Seminar/GetUpcomingSeminarsAsync?pageNo=${pageNo}&pageSize=${pageSize}`

    if (monthNumber) {
      requestUrl = requestUrl + `&MonthNumber=${monthNumber}`
    }
    if (startDate && endDate) {
      requestUrl =
        requestUrl + `&FromDateRange=${startDate}&ToDateRange=${endDate}`
    }
    if (subjectIds) {
      requestUrl = requestUrl + `${subjectIds}`
    }

    return requestUrl
  }
  return await api(
    getURLBasedOnInputs(monthNumber, startDate, endDate, subjectIds)
  )
}
export const getSeminarsPast = async (
  pageNo,
  pageSize,
  monthNumber,
  startDate,
  endDate,
  subjectIds
) => {
  function getURLBasedOnInputs(monthNumber, startDate, endDate, subjectIds) {
    let requestUrl = `/Seminar/Seminar/GetPastSeminarsAsync?pageNo=${pageNo}&pageSize=${pageSize}`

    if (monthNumber) {
      requestUrl = requestUrl + `&MonthNumber=${monthNumber}`
    }
    if (startDate && endDate) {
      requestUrl =
        requestUrl + `&FromDateRange=${startDate}&ToDateRange=${endDate}`
    }
    if (subjectIds) {
      requestUrl = requestUrl + `${subjectIds}`
    }

    return requestUrl
  }
  return await api(
    getURLBasedOnInputs(monthNumber, startDate, endDate, subjectIds)
  )
}

export const getSeminarsViaDegree = async id => {
  return await api(
    `/Seminar/admin/Seminar/GetAllSeminarByDegreeGroupID?DegreeGroupID=${id}`
  )
}

export const deleteSeminar = async id => {
  return await api(`/Seminar/admin/Seminar/${id}`)
}

export const getSeminarFiles = async id => {
  return await api(`/Seminar/Seminar/ViewSeminarFileById?id=${id}`)
}

export const getCoursesUpcoming = async (
  pageNo,
  pageSize,
  startDate,
  endDate,
  title
) => {
  function getURLBasedOnInputs(startDate, endDate, title) {
    let requestUrl = `/Course/Course/GetUpcomingCourses?PageNo=${pageNo}&PageSize=${pageSize}`

    if (startDate && endDate) {
      requestUrl =
        requestUrl + `&FromDateRange=${startDate}&ToDateRange=${endDate}`
    }
    if (title) {
      requestUrl = requestUrl + `&CourseTitle=${title}`
    }

    return requestUrl
  }
  return await api(getURLBasedOnInputs(startDate, endDate, title))
}

export const getCoursesPast = async (
  pageNo,
  pageSize,
  startDate,
  endDate,
  title
) => {
  function getURLBasedOnInputs(startDate, endDate, title) {
    let requestUrl = `/Course/Course/GetPastCourses?PageNo=${pageNo}&PageSize=${pageSize}`

    if (startDate && endDate) {
      requestUrl =
        requestUrl + `&FromDateRange=${startDate}&ToDateRange=${endDate}`
    }
    if (title) {
      requestUrl = requestUrl + `&CourseTitle=${title}`
    }

    return requestUrl
  }
  return await api(getURLBasedOnInputs(startDate, endDate, title))
}

export const getCourseFiles = async id => {
  return await api(`/Course/Course/ViewCourseFileById?id=${id}`)
}

export const getTutionDashboard = async () =>
  await api(`/Tution/Tution/GetDashboardData`)

export const getTutionDashboardNew = async () =>
  await api(`/Tution/Tution/GetDashboardDataNew`)

export const getTutionDashboardUnlimited = async () =>
  await api(`/Tution/Tution/GetDashboardDataUnlimited`)

export const getStudentDashboardData = async () =>
  await api(`/Dashboard/Dashboard/GetDashboardDataV2`)

export const getDegreeGroups = async () =>
  await api(`/Subject/Degree/GetAllDegreeGroup`)

export const getTutionCalendar = async () =>
  await api(`/Tution/Tution/GetCalendarData`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })

export const getCurriculumData = async monthNum => {
  return await api(
    `/Curriculum/Curriculum/GetStudentCurriculumV2?monthNumber=${monthNum}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }
  )
}

export const getParentCalendar = async () =>
  await api(`/Tution/parent/Tution/GetCalendarData`)

export const getParentNotification = async () =>
  await api(
    `/Notification/Parent/Notification/GetAllNotificationLogUnExpired`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }
  )

export const getSchoolNotification = async () =>
  await api(
    `/Notification/School/Notification/GetAllNotificationLogUnExpired`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }
  )

export const getTutorDashboardData = async () =>
  await api(`/User/tutor/AuditDashboard/AuditDashboard`)

export const getQuestionBankData = async () =>
  await api(`/Exam/Simulate/SimulateStatistics`)

export const getLearningAdmin = async () =>
  await api("/training/admin/Learning")

export const getTutorNotification = async () =>
  await api(`/Question/tutor/QuestionFlag/FlaggedQuestionNotifyToTutor`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })

export const getStudentMetadata = async () =>
  await api(`/user/student/meta-data`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })

export const getBookingLight = async () =>
  await api(`/crosscontextquery/CrossContextQuery/booking-light`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
    })

export const getLessonPlansAndGuides = async () =>
  await api(`/Miscellaneous/tutordownloadable`)

export const getMultiYearCurriculums = async () =>
  await api(`/Curriculum/MultiYearCurriculum`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })

export const getMultiYearCurriculumById = async (id) =>
  await api(`/Curriculum/MultiYearCurriculum/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })

export const createMultiYearCurriculum = async (body) =>
  await api.post(`/Curriculum/MultiYearCurriculum/Create`, body, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })

export const updateMultiYearCurriculum = async (body) =>
  await api.post(`/Curriculum/MultiYearCurriculum/Update`, body, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })

export const deleteMultiYearCurriculum = async (id) =>
  await api.post(`/Curriculum/MultiYearCurriculum/Delete`, { id }, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })


  export const getDegreesAuthorized = async () => await api(`/Subject/Degree`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })

  export const getAdmissionTestsAuthorized = async () => await api(`/Subject/AdmissionTest`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })

export const getStudentOnboarding = async () =>
  await api(`/User/Student/onboarding`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  })